const lang = {
    en: {
      search: "Search",
      gptSearchPlaceholder: "What would you like to watch today?",
    },
    hindi: {
      search: "खोज",
      gptSearchPlaceholder: "आज आप क्या देखना चाहेंगे?",
    },
    spanish: {
      search: "buscar",
      gptSearchPlaceholder: "¿Qué te gustaría ver hoy?",
    },
    tamil: {
        search: "தேடு",
        gptSearchPlaceholder: "இன்று நீங்கள் எதைப் பார்க்க விரும்புகிறீர்கள்?",
      },
  };
  
  export default lang;